import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import HeadTags from './utils/HeadTags';
import {
  ErrorBoundary,
  ErrorFallback,
  type IFallbackProps,
} from '@troverecommerce/saas-components-ts';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const FallbackComponent:React.FC<IFallbackProps> = ({
  error: _error,
  resetErrorBoundary: _resetErrorBoundary,
}) => (
  <ErrorFallback
    title="An unexpected error occurred."
    description="We're sorry for the inconvenience. Please refresh the page and try again."
    type="error"
  />
);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <HeadTags />
      <ErrorBoundary FallbackComponent={FallbackComponent}>
        <App />
      </ErrorBoundary>
    </HelmetProvider>
  </React.StrictMode>,
);
